// extracted by mini-css-extract-plugin
export default {"comment-box":"CommentBox_comment-box__A4b+M","character-count":"CommentBox_character-count__6jL9O"};